module.exports = __webpack_public_path__ + "static/media/Clem.66edce66.png";